export const DEFAULT_TIMEZONE_LOCAL =
  Intl.DateTimeFormat().resolvedOptions().timeZone;
